module.exports = __webpack_public_path__ + "img/22-2.e7c698a9.png";